module.exports = require("body-parser");


/*****************
 ** WEBPACK FOOTER
 ** external "body-parser"
 ** module id = 2
 ** module chunks = 0
 **/